import styled from "styled-components";
import SegmentedControl from "../SegmentedControl/SegmentedControl";
import { pxToRem } from "../../styles/utils";

const segmentedControlProps = new Set([
  "value",
  "options",
  "onChange",
  "ariaLabel",
  "className",
]);

export const ToggleSwitchContainer = styled(SegmentedControl).withConfig({
  shouldForwardProp: (prop) => segmentedControlProps.has(prop),
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: none;
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xl)};
  padding: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  overflow: visible;
  border: none;
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.canvas};

  button {
    height: ${({ theme }) => pxToRem(theme.controlHeight.sm)};
    flex: 1 1 0;
    padding: 0 ${({ theme }) => pxToRem(theme.spacing.md)};
    border: none;
    border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
    background: transparent;
    color: ${({ theme }) => theme.colors.grayCool};
    font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s, opacity 0.2s;
  }

  button[aria-pressed="true"] {
    background: ${({ theme }) => theme.colors.brand};
    color: ${({ theme }) => theme.colors.white};
  }

  button:not([aria-pressed="true"]):hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.inkSurface};
    color: ${({ theme }) => theme.colors.brand};
  }

  button[aria-pressed="true"]:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.brandDark};
    color: ${({ theme }) => theme.colors.white};
  }

  button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;
